import ErrorPage from 'components/ErrorPage';
import LoadingSpinner from 'components/LoadingSpinner';
import MeetingStatus from 'enums/MeetingStatus';
import useInterval from 'hooks/useInterval';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCachedQuestionsAction, getStatusAction } from 'store/conference/conferenceActions';
import ConferenceStyleWrapper from '../conference-wrapper/ConferenceWrapper';
import JoinMeetingPopup from './components/JoinMeetingPopup';
import ViewContainer from './components/views/ViewContainer';
export default function PresenterView() {
  const dispatch = useDispatch();
  const { hasJoined, meetingStatus, errorMessage, isRecordingUser } = useSelector(
    ({ classroom, chime, user }) => ({
      hasJoined: chime.hasJoined,
      meetingStatus: chime.meetingStatus,
      errorMessage: classroom.actionStatus.joinMeeting?.error,
      user: user.isRecordingUser,
    })
  );
  useInterval(async () => {
    dispatch(getStatusAction());
  }, 5000);

  useInterval(async () => {
    if (!isRecordingUser) {
      dispatch(getCachedQuestionsAction());
    }
  }, 10000);

  return (
    <div>
      {meetingStatus === MeetingStatus.Loading && <LoadingSpinner />}
      {meetingStatus === MeetingStatus.Failed && <ErrorPage errorMessage={errorMessage} />}
      {meetingStatus === MeetingStatus.Succeeded && (
        <>
          {hasJoined ? (
            <ConferenceStyleWrapper>
              <ViewContainer id="presenter-view" />
            </ConferenceStyleWrapper>
          ) : (
            <JoinMeetingPopup id="presenter-join-meeting-popup" />
          )}
        </>
      )}
    </div>
  );
}
